// extracted by mini-css-extract-plugin
export default {"devider":"styles_devider__fwwC2","block-label":"styles_block-label__lnbut","arrow":"styles_arrow__K-+tJ","arrow_active":"styles_arrow_active__SOUx7"};